// Hand-rolled replacement for the abandoned webcamjs vendor library. Drop-in for the
// subset of the webcamjs 1.0.26 API used by document_verification.js and page-18.js:
// set()/attach()/snap()/reset(). Relies on the global `notify` (loaded via main.js),
// same convention as lib/coverage-check.js.

let opts = {
    image_format: 'jpeg',
    jpeg_quality: 90,
    width: 320,
    height: 240,
};
let stream = null;
let video = null;

function set(newOpts) {
    opts = Object.assign({}, opts, newOpts);
}

function attach(selector) {
    const container = document.querySelector(selector);
    if (!container) {
        return;
    }

    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        notify.error('Camera access is not supported in this browser.');
        return;
    }

    navigator.mediaDevices
        .getUserMedia({
            video: {
                width: { ideal: opts.width },
                height: { ideal: opts.height },
            },
            audio: false,
        })
        .then(function (mediaStream) {
            stream = mediaStream;
            video = document.createElement('video');
            video.autoplay = true;
            video.playsInline = true;
            video.muted = true;
            // Mirror the live preview only (matches webcamjs's default flip_horiz: true).
            // snap() draws the video element's decoded frame, not its CSS-transformed
            // rendered box, so the captured still comes out un-mirrored automatically -
            // matching webcamjs's own auto-un-mirror behavior on capture.
            video.style.transform = 'scaleX(-1)';
            video.srcObject = mediaStream;
            container.innerHTML = '';
            container.appendChild(video);
        })
        .catch(function () {
            notify.error('Unable to access your camera. Please check camera permissions and try again.');
        });
}

function snap(callback) {
    if (!video || !stream) {
        return;
    }
    const canvas = document.createElement('canvas');
    canvas.width = opts.width;
    canvas.height = opts.height;
    canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
    const quality = (opts.jpeg_quality || 90) / 100;
    callback(canvas.toDataURL('image/' + (opts.image_format || 'jpeg'), quality));
}

function reset() {
    if (stream) {
        stream.getTracks().forEach(function (track) {
            track.stop();
        });
        stream = null;
    }
    if (video) {
        video.srcObject = null;
        if (video.parentNode) {
            video.parentNode.removeChild(video);
        }
        video = null;
    }
}

export default { set, attach, snap, reset };
